<mat-sidenav-container (backdropClick)="closeSlideBar()">
  <mat-sidenav position="end" [opened]="sideBarOpened">
    <router-outlet name="sidebar"></router-outlet>
  </mat-sidenav>
  <mat-sidenav-content id="main">
    <h1 class="center">Livraisons</h1>
    <nav>
      <a routerLinkActive="active-link" routerLink="./list"
        hideIfNot="!ROLE_LECTURECAB||ROLE_ANETT||ROLE_ADMINISTRATION">Liste des
        livraisons</a>
      <a routerLinkActive="active-link" routerLink="./schedule">Passages des livraisons</a>
    </nav>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>